/*
 * Copyright (c) 2022. American Express Company
 */

export enum CursorStyle {
    DEFAULT = 'default',
    MOVE = 'move',
    CROSSHAIR = 'crosshair'
}
